import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AddConsultationCalendarDialogComponent } from "src/app/pages/add-consultation-calendar-dialog/add-consultation-calendar-dialog.component";
import { canBuildConsultationCalendarEvent } from "src/app/utils/consultation-calendar.util";

@Injectable({
  providedIn: "root",
})
export class ConsultationCalendarDialogService {
  constructor(private dialog: MatDialog) {}

  /** Opens provider picker (Google / Outlook / .ics). No-op if consultation has no parseable date/time. */
  open(consultation: any): void {
    if (!consultation || !canBuildConsultationCalendarEvent(consultation)) {
      return;
    }
    this.dialog.open(AddConsultationCalendarDialogComponent, {
      width: "440px",
      maxWidth: "95vw",
      data: { consultation },
      autoFocus: ".acc-option",
      panelClass: "acc-dialog-panel",
    });
  }
}
